import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          
          {/* Contact Section */}
          <div className="text-center md:text-left">
            <h4 className="text-xl font-semibold mb-4 text-green-400">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <p><strong>GREEN ENERGY PARK</strong></p>
              <p>Téléphone : +212 (0) 537 68 22 36 / Fax : +212 (0) 537 68 88 52</p>
              <p>Adresse : Route Régionale R206 Benguerir, Maroc</p>
              <p>Email : <a href="mailto: elainaoui@greenenergypark.ma" className="text-green-400 hover:underline">elainaoui@greenenergypark.ma</a></p>
            </div>
          </div>

          {/* Google Maps Section */}
          <div className="text-center md:text-left">
            <h4 className="text-xl font-semibold mb-4 text-green-400">Location</h4>
            <div className="bg-gray-700 rounded-lg overflow-hidden h-48">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13501.494609613437!2d-7.929036260514733!3d32.22110419859592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdaf7a47849efc6f%3A0x53aa20c469abf33f!2sGreen%20Energy%20Park!5e0!3m2!1sen!2sma!4v1756338554283!5m2!1sen!2sma"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="GREEN ENERGY PARK Location"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Simple Bottom Section */}
        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} GEPredict. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
